<template>
  <div class="listContentManage">
    <!-- 表格 -->
    <basic-container>
      <div class="query-form-wrap">
        <el-form :inline="true" :model="searchForm" :size="formSize" label-width="88px">
          <el-form-item v-if="tableTabs === 'live'">
            <el-date-picker v-model="searchForm.liveTime" style="width: 250px;" size="small" clearable
              type="datetimerange" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions" range-separator="至" start-placeholder="直播开始日期" end-placeholder="直播结束日期"
              :default-time="['00:00:00', '23:59:59']"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker class="dateSelect" v-model="searchForm.date" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <!-- 关联应用 -->
          <el-form-item v-if="tableTabs !== 'lbMedia'">
            <el-select size="small" filterable clearable v-model="searchForm.thirdPartyAppId" placeholder="关联应用">
              <el-option v-for=" item in aplicationTypeList " :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select size="small" filterable clearable v-model="searchForm.status" placeholder="状态">
              <el-option v-for="( item, index ) in statusList  " :key="index" :label="item.bizKey"
                :value="item.bizValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="tableTabs === 'films' || tableTabs === 'lbMedia'">
            <el-input v-model="searchForm.title" clearable placeholder="内容标题"></el-input>
          </el-form-item>
          <el-form-item v-if="tableTabs === 'live'">
            <el-input v-model="searchForm.teamInformation" clearable placeholder="队伍信息"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-auth="'LIST_CONTENT_MANAGE_SEARCH'" type="primary" @click="getListContent(1)">搜索</el-button>
            <el-button v-auth="'LIST_CONTENT_MANAGE_ADD'" plain @click="handleClick('', 1)">新增</el-button>
            <el-button type="success" @click="showImport">投屏榜媒资导入</el-button>
            <el-button type="warning" @click="() => { $refs.importLbMedia && $refs.importLbMedia.show() }">媒资库内容导入</el-button>
          </el-form-item>
        </el-form>
        <el-tabs v-model="tableTabs" @tab-click="tableTabChange">
          <el-tab-pane label="直播赛事" name="live">
            <el-table border :data="tableData" height="600px" style="width: 100%">
              <el-table-column prop="id" label="ID" width="180">
              </el-table-column>
              <el-table-column prop="teamA" label="队伍信息" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.teamA }}</span> VS <span>{{ scope.row.teamB }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="coverImg" label="队伍图片" width="150">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: center;">
                    <el-image style="width: 50px; height: 50px" :src="scope.row.teamAImg"
                      :preview-src-list="[scope.row.teamAImg]" @click.stop="handleClickItem">
                    </el-image> <span> VS </span>
                    <el-image style="width: 50px; height: 50px" :src="scope.row.teamBImg"
                      :preview-src-list="[scope.row.teamBImg]" @click.stop="handleClickItem">
                    </el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="thirdPartyAppName" label="关联应用">
              </el-table-column>
              <el-table-column prop="matchStartTime" label="直播时间" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.matchStartTime }} - {{ scope.row.matchEndTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="liveStatus" label="直播状态">
                <template slot-scope="scope">
                  <!-- 直播状态,1：未开始；2：直播中；3：已结束 -->
                  <span v-if="scope.row.liveStatus === 1">未开始</span>
                  <span v-else-if="scope.row.liveStatus === 2">直播中</span>
                  <span v-else-if="scope.row.liveStatus === 3">已结束</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                  <!-- 增加待上架 -->
                  <!-- 0：失效；1：生效；2：待生效） -->
                  <span v-if="scope.row.status === 0">下架</span>
                  <span v-else-if="scope.row.status === 1">上架</span>
                  <span v-else-if="scope.row.status === 2">待上架</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间">
              </el-table-column>
              <!-- 上架时间 -->
              <el-table-column prop="effectStartTime" label="上架时间">
                <template slot-scope="scope">
                  <!-- - 【新增】“上架时段”列表字段，下架时不显示，上架时显示指定时间或时段 -->
                  <span v-if="scope.row.status !== 0">{{ scope.row.effectStartTime }} 至 {{ scope.row.effectEndTime
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                  <el-button v-auth="'LIST_CONTENT_MANAGE_LOG'" @click="viewLog(scope.row)" type="text"
                    size="small">日志</el-button>
                  <el-button v-auth="'LIST_CONTENT_MANAGE_COPY'" @click="handleClick(scope.row, 4, '')" type="text"
                    size="small">复制</el-button>
                  <el-button v-auth="'LIST_CONTENT_MANAGE_EDIT'" @click="handleClick(scope.row, 2)" type="text"
                    size="small">编辑</el-button>
                  <el-button v-auth="'LIST_CONTENT_MANAGE_DEL'" @click="handleClick(scope.row, 3)" type="text"
                    size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="影视资源" name="films">
            <el-table border :data="tableData" height="600px" style="width: 100%">
              <el-table-column prop="id" label="ID" width="180">
              </el-table-column>
              <el-table-column prop="title" label="内容标题" width="180">
              </el-table-column>
              <el-table-column prop="coverImg" label="内容图片" width="180">
                <template slot-scope="scope">
                  <el-image style="width: 50px; height: 50px" :src="scope.row.coverImg"
                    :preview-src-list="[scope.row.coverImg]" @click.stop="handleClickItem">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column prop="hdCoverImg" label="高清封面图片" width="180">
                <template slot-scope="scope">
                  <el-image style="width: 50px; height: 50px" :src="scope.row.hdCoverImg"
                    :preview-src-list="[scope.row.hdCoverImg]" @click.stop="handleClickItem">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column prop="displayOrder" label="显示顺序">
              </el-table-column>
              <el-table-column prop="tags" label="宣传标签">
              </el-table-column>
              <el-table-column prop="thirdPartyAppName" label="关联应用">
              </el-table-column>
              <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                  <!-- 增加待上架 -->
                  <!-- 0：失效；1：生效；2：待生效） -->
                  <span v-if="scope.row.status === 0">失效</span>
                  <span v-else-if="scope.row.status === 1">生效</span>
                  <span v-else-if="scope.row.status === 2">待生效</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建日期">
              </el-table-column>
              <el-table-column prop="remark" label="备注">
              </el-table-column>
              <!-- 上架时间 -->
              <el-table-column prop="effectStartTime" label="上架时间">
                <template slot-scope="scope">
                  <!-- - 【新增】“上架时段”列表字段，下架时不显示，上架时显示指定时间或时段 -->
                  <span v-if="scope.row.status !== 0">{{ scope.row.effectStartTime }} 至 {{ scope.row.effectEndTime
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                  <el-button v-auth="'LIST_CONTENT_MANAGE_LOG'" @click="viewLog(scope.row)" type="text"
                    size="small">日志</el-button>
                  <el-button v-auth="'LIST_CONTENT_MANAGE_COPY'" @click="handleClick(scope.row, 4, '')" type="text"
                    size="small">复制</el-button>
                  <el-button v-auth="'LIST_CONTENT_MANAGE_EDIT'" @click="handleClick(scope.row, 2)" type="text"
                    size="small">编辑</el-button>
                  <el-button v-auth="'LIST_CONTENT_MANAGE_DEL'" @click="handleClick(scope.row, 3)" type="text"
                    size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="乐播媒资" name="lbMedia">
            <media-table
              :tableData="tableData"
              @clickImg="handleClickItem"
              @edit="row => { handleClick(row, 2) }"
              @viewLog="row => { viewLog(row) }"
              @del="row => { handleClick(row, 3) }"
            />
          </el-tab-pane>
        </el-tabs>
        <div class="block">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pagination.current" :page-sizes="[10, 50, 100, 200]" :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
          </el-pagination>
        </div>
      </div>
    </basic-container>
    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="title" append-to-body :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="visible" width="50%" @close="onDialogClose" class="custom-dialog-min-width">
      <el-tabs v-model="addTabs">
        <el-tab-pane :disabled="type === 2 && addTabs !== 'live'" label="直播赛事" name="live">
          <LiveForm ref="liveForm" @close="onDialogClose" @reload="getListContent"></LiveForm>
        </el-tab-pane>
        <el-tab-pane :disabled="type === 2 && addTabs !== 'films'" label="影视内容" name="films">
          <div v-loading="loading" class="dialog-content-wrap">
            <el-form :model="dialogForm" :rules="rules" ref="editForm" size="small" label-width="140px">
              <el-form-item v-for="( item ) in dialogForm.config " :key="item.id" :label="item.label" :prop="item.name"
                :ref="item.name">
                <!-- 文本框 -->
                <el-input v-if="item.type === 'input'" v-model="item.value" style="width: 400px;"
                  :placeholder="item.placeholder"></el-input>
                <!-- 下拉选择 -->
                <el-select v-if="item.type === 'select'" v-model="item.value" :placeholder="item.placeholder">
                  <el-option v-for=" item in aplicationTypeList " :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <!-- 内容标签 -->
                <el-input v-if="item.id === 51" v-model="item.value" style="width: 200px;margin-right: 10px;"
                  :placeholder="item.placeholder"></el-input> <el-button v-if="item.id === 51" size="small"
                  @click="insertCategory">添加</el-button>
                <div style="margin-top: 10px;" v-if="item.id === 51 && dialogForm.category">
                  <el-tag style="margin-right: 10px;" closable v-for="( item, index ) in contentList " :key="item"
                    @close="(() => {
                      dialogForm.category = contentList.filter((tag, i) => i != index).join(',')

                    })">{{ item }}</el-tag>
                </div>
                <!-- 文本域 -->
                <el-input v-if="item.type === 'textarea'" type="textarea" :rows="2" :placeholder="item.placeholder"
                  v-model="item.value" style="width: 400px;"></el-input>
                <!-- 单选 -->
                <el-radio-group v-if="item.type === 'radio'" v-model="item.value">
                  <el-radio :label="1">上架</el-radio>
                  <el-radio :label="0">下架</el-radio>
                </el-radio-group>
                <!-- 上传 -->
                <el-upload v-if="item.type === 'upload'" action="#" list-type="picture-card"
                  :on-preview="(file) => { return handlePictureCardPreview(file, item) }" :auto-upload="false"
                  :file-list="uploadList(item.name)"
                  :on-change="(file, file_list) => { return handleChangeImgs(file, file_list, item.name) }"
                  :on-remove="(file, file_list) => { return handleRemoveImgs(file, file_list, item) }" :limit="1">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div v-if="item.type === 'picSelectWidth'">
                  <el-radio-group v-model="imgSelectWidth">
                    <el-radio label="300">小图：300px (推荐)</el-radio>
                    <el-radio label="700">大图：700px (推荐)</el-radio>
                    <el-radio :label="-1">自定义图片宽度</el-radio>
                  </el-radio-group>
                  <el-popover placement="top-start" width="200" trigger="hover" content="如果输入了自定义图片宽度，以自定义图片宽度为准">
                    <i class="el-icon-question" slot="reference" style="margin-left: 40px;color: #507dc5;"></i>
                  </el-popover>
                </div>
                <el-input v-if="item.type === 'picInputWidth' && imgSelectWidth === -1" v-model="item.value"
                  style="width: 400px;" clearable :placeholder="item.placeholder"></el-input>
                <el-dialog v-if="item.type === 'upload'" :visible.sync="dialogVisible" append-to-body>
                  <img width="100%" :src="item.value" />
                </el-dialog>
                <!-- 嵌套 -->
                <div v-if="item.children" style="height: 32px;"></div>
                <div class="children" v-for="(subItem) in item.children" :key="subItem.id">
                  <div class="title">{{ subItem.label }}</div>
                  <el-input v-model="subItem.value" maxlength="998" :placeholder="subItem.placeholder"
                    style="width: 400px;"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="状态" prop="status">
                <el-radio-group v-model="dialogForm.status">
                  <el-radio :label="1">生效</el-radio>
                  <el-radio :label="0">失效</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 生效模式 -->
              <el-form-item v-if="dialogForm.status === 1" label="选择" prop="effectMode">
                <!-- 立即生效 1  指定时间生效 2 -->
                <el-radio-group v-model="dialogForm.effectMode">
                  <el-radio :label="1">立即生效</el-radio>
                  <el-radio :label="2">指定时间生效</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 生效时间 -->
              <el-form-item class="effectTime" v-if="dialogForm.status === 1 && dialogForm.effectMode === 2"
                label="生效时间" prop="effectTime">
                <el-date-picker size="small" :picker-options="{
                  disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                  },
                }" v-model="dialogForm.effectTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
                  range-separator="至" start-placeholder="生效开始时间" end-placeholder="生效结束时间" clearable>
                </el-date-picker>
              </el-form-item>
            </el-form>
            <div class="btn">
              <el-button size="mini" type="primary" @click="handleEdit">保存</el-button>
              <el-button size="mini" @click="onDialogClose">取消</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :disabled="type === 1 || (type === 2 && addTabs !== 'lbMedia')" label="乐播媒资" name="lbMedia">
          <MediaForm ref="lbMediaForm" @close="onDialogClose" @reload="getListContent"></MediaForm>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <ImportDialog ref="importDialog" @reload="getListContent" />
    <!-- 乐播媒资导入 -->
    <import-lb-media ref="importLbMedia" @reload="getListContent" />
    <!-- 操作日志 -->
    <OptionLog ref="optionLog" :columnConfig="optionLogColumn" @reload="reloadOpt" :closeBtn="false">
      <template #type="{ row }">
        <div>
          <!-- 操作类型(1-新增, 2-修改, 3-删除 -->
          <span v-if="row.type === 1">新增</span>
          <span v-if="row.type === 2">修改</span>
          <span v-if="row.type === 3">删除</span>
        </div>
      </template>
    </OptionLog>
  </div>
</template>
<script>
import { putFile } from '@/api/app';
import { deleteListContent, getListContent, getListContentDetail, getLogList, getRelevanceApp, updateListContent } from '@/api/listContentManage/index.js';
import OptionLog from "@/components/OptionsLog/optionLog.vue";
import { extractWidth, processImageUrl } from "@/util/pic";
import { cloneDeep } from 'lodash';
import ImportDialog from './components/import.vue';

import Vue from 'vue';
import LiveForm from './components/liveForm.vue';
import MediaTable from './components/mediaTab/mediaTable.vue';
import MediaForm from './components/mediaTab/mediaForm.vue';
import ImportLbMedia from './components/mediaTab/importMedia.vue'
export default {
  name: 'listContentManage',
  provide() {
    return {
      thirdPartyAppList: this.thirdPartyAppList
    }
  },
  components: {
    ImportLbMedia,
    MediaTable,
    MediaForm,
    ImportDialog,
    OptionLog,
    LiveForm
  },
  computed: {
    // 标签数组
    contentList() {
      return this.dialogForm.category.split(',')
    },
    // 标题
    title() {
      return this.type === 1 ? '新增' : '编辑'
    }
  },
  data() {
    return {
      /** 操作日志配置列 */
      optionLogColumn: [
        {
          prop: "operateTime",
          label: "操作时间",
        },
        {
          prop: "operator",
          label: "操作人",
        },
        {
          prop: "type",
          label: "操作类型",
          slot: "type",
        }
      ],
      // 查询条件
      searchForm: {
        liveTime: [],
        date: [],
        thirdPartyAppId: '',
        status: '',
        title: '',
        teamInformation: ''
      },
      // 字体大小
      formSize: "small",
      // 播放来源
      playSourceList: [],
      tableData: [],
      pagination: {
        // 当前页
        current: 1,
        // 单页数量
        size: 10,
        // 列表总数量
        total: 0
      },
      // 新增/编辑弹窗
      visible: false,
      // 新增/编辑框内容
      dialogForm: {
        /** 内容标签 */
        category: '',
        /** 状态 */
        status: "",
        /** 生效模式 1：立即生效；2：指定时间生效 */
        effectMode: "",
        /** 生效时间 */
        effectTime: [],
        config: [
          {
            label: '内容名称：',
            value: '',
            name: 'title',
            type: 'input',
            placeholder: '内容标题',
            id: 1,
          },
          {
            label: '内容图片：',
            value: '',
            name: 'coverImg',
            type: 'upload',
            id: 2
          },
          {
            label: '高清封面图片：',
            value: '',
            name: 'hdCoverImg',
            type: 'upload',
            id: 12
          },
          {
            label: '图片宽度尺寸',
            value: '',
            name: 'imgWidthSelect',
            type: 'picSelectWidth',
            placeholder: '选择图片宽度',
            id: 11
          },
          {
            label: ' ',
            value: '',
            name: 'imgWidth',
            type: 'picInputWidth',
            placeholder: '请输入图片宽度(单位px)',
            id: 10
          },
          {
            label: '显示顺序：',
            value: '',
            name: 'displayOrder',
            type: 'input',
            placeholder: '按照顺序进行显示, 相同数字按顺序排序',
            id: 3
          },
          {
            label: '热度值：',
            value: '',
            name: 'hotScore',
            type: 'input',
            placeholder: '输入正整数',
            id: 4
          },
          {
            label: '宣传标签：',
            value: '',
            name: 'tags',
            type: 'input',
            placeholder: '输入文案',
            id: 5
          },
          {
            id: 51,
            label: '内容标签',
            value: '',
            name: 'categoryInput',
            placeholder: '输入文案',
          },
          {
            label: '描述：',
            value: '',
            name: 'description',
            type: 'input',
            placeholder: '输入文案',
            id: 6
          },
          {
            label: '关联应用：',
            value: '',
            name: 'thirdPartyAppId',
            type: 'select',
            id: 7
          },
          {
            label: '单片跳转链接：',
            name: 'link',
            id: 8,
            children: [

              {
                label: 'Android_Scheme：',
                value: '',
                name: 'androidScheme',
                type: 'input',
                placeholder: '输入Android端的Scheme链接'
              },
              {
                label: 'Android_app_link：',
                value: '',
                name: 'androidAppLink',
                type: 'input',
                placeholder: '输入Android端的通用跳转链接'
              },
              {
                label: 'Android_pad_Scheme：',
                value: '',
                name: 'androidPadScheme',
                type: 'input',
                placeholder: '输入Android_pad端的Scheme链接'
              }, {
                label: 'iOS_Scheme：',
                value: '',
                name: 'iosScheme',
                type: 'input',
                placeholder: '输入iOS端的Scheme链接'
              }, {
                label: 'iOS_app_link：',
                value: '',
                name: 'appLink',
                type: 'input',
                placeholder: '输入iOS端的通用跳转链接'
              }, {
                label: 'iPad_Scheme：',
                value: '',
                name: 'ipadScheme',
                type: 'input',
                placeholder: '输入ipad端的Scheme链接'
              }]
          }
          , {
            label: '备注：',
            value: '',
            name: 'remark',
            type: 'textarea',
            placeholder: '输入文案',
            id: 9
          },
        ],
      },
      // 新增/编辑放大的图片
      dialogImageUrl: '',
      /// 新增/编辑放大的图片显示/隐藏
      dialogVisible: false,
      rules: {
        // 内容名称
        title: [
          {
            required: true,
            validator: (rule, value, callback) => {
              let formValue = this.dialogForm.config.find(item => item.name === rule.field).value;
              if (!formValue) {
                return callback(new Error('该项为必填项'));
              }
              if (formValue.length > 99) return callback(new Error('输入内容不能超过 99 个字符'));
              callback();
            },
            trigger: 'change'
          }
        ],
        // 热度值
        hotScore: [
          {
            required: false,
            validator: (rule, value, callback) => {
              let formValue = this.dialogForm.config.find(item => item.name === rule.field).value;
              if (!/^[1-9]\d*$/.test(formValue.toString())) {
                callback(new Error('请输入正整数'));
              } else {
                callback();
              }
            },
            trigger: ['change', 'blur']
          }
        ],
        // 宣传标签
        tags: [{
          validator: (rule, value, callback) => {
            let formValue = this.dialogForm.config.find(item => item.name === rule.field).value;
            if (formValue.length > 99) {
              callback(new Error('输入内容不能超过 99 个字符'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        // 描述
        description: [{
          validator: (rule, value, callback) => {
            let formValue = this.dialogForm.config.find(item => item.name === rule.field).value;
            if (formValue.length > 99) {
              callback(new Error('输入内容不能超过 99 个字符'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        // 关联应用
        thirdPartyAppId: [{
          required: true,
          validator: (rule, value, callback) => {
            let formValue = this.dialogForm.config.find(item => item.name === rule.field).value;
            if (!formValue) {
              callback(new Error('该项为必选项'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        // 跳转链接
        link: [
          {
            validator: (rule, value, callback) => {
              let formChild = this.dialogForm.config.find(item => item.name === rule.field).children;
              let obj = {}
              formChild.forEach(ele => {
                obj[ele.name] = ele.value
              });
              if (!obj.androidScheme) {
                return callback(new Error('Android_Scheme该项为必填项'));
              }
              if (!obj.iosScheme && !obj.appLink) {
                return callback(new Error('iOS_Scheme：与iOS_app_link至少填一个'));
              }
              callback();
            },
          }
        ],
        // 内容图片
        coverImg: [
          {
            required: true,
            validator: (rule, value, callback) => {
              let formValue = this.dialogForm.config.find(item => item.name === rule.field).value;
              if (!formValue) {
                return callback(new Error('内容图片必须上传'));
              }
              callback();
            },
            trigger: 'change'
          }
        ],
        // 状态
        status: [
          {
            required: true,
            validator: (rule, value, callback) => {
              let formValue = this.dialogForm.status;
              if (formValue === '' || formValue === null || formValue === undefined) {
                return callback(new Error('请选择状态'));
              }
              callback();
            },
          }],
        effectMode: [
          { required: true, message: "请选择生效模式", trigger: "blur" },
        ],
        effectTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              console.log("生效时间", value);
              if (value === undefined || value.length === 0) {
                callback(new Error("请选择生效时间"));
              } else {
                // 校验开始时间，大于当前时间
                if (value[0]) {
                  // 将字符串格式的开始时间转换为Date对象
                  const startTime = new Date(value[0]);

                  // 检查转换是否成功，且开始时间是否大于当前时间
                  if (
                    isNaN(startTime.getTime()) ||
                    startTime.getTime() < Date.now()
                  ) {
                    callback(new Error("生效开始时间不能小于当前时间"));
                  }
                }
                if (value[1]) {
                  // 将字符串格式的结束时间转换为Date对象
                  const endTime = new Date(value[1]);

                  // 检查转换是否成功，且结束时间是否大于开始时间
                  if (
                    isNaN(endTime.getTime()) ||
                    endTime.getTime() < new Date(value[0]).getTime()
                  ) {
                    callback(new Error("生效结束时间不能小于开始时间"));
                  }
                }
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      // 状态下拉列表
      statusList: [
        {
          bizValue: 1,
          bizKey: '上架'
        },
        {
          bizValue: 0,
          bizKey: '下架'
        }
      ],
      loading: false,
      // 当前已上传的图片列表
      coverImg: [],
      // 关联应用
      aplicationTypeList: [],
      // 编辑id
      editId: '',
      // 新增/编辑
      type: 1,
      // 上传图片选择宽度
      imgSelectWidth: '300',
      // 表格tab： 影视资源films 直播资源live 乐播媒资lbMedia
      tableTabs: 'films',
      // 新增/编辑tab：影视资源films 直播资源live 乐播媒资lbMedia
      addTabs: 'films',
      // 第三方关联应用
      thirdPartyAppList: Vue.observable({
        value: []
      }),
      /** 直播日期选择配置 */
      pickerOptions: {
        onPick({ maxDate, minDate }) {
          if (maxDate) {
            maxDate.setSeconds(0);
          }
          if (minDate) {
            minDate.setSeconds(0);
          }
        }
      },
    }
  },
  created() {
    // 获取榜单列表
    this.getListContent()
    // 获取关联应用
    this.getRelevanceApp()
  },
  methods: {
    /** 查看日志 */
    async viewLog(row) {
      console.log("查看日志", row.id);
      const optSearch = this.$refs.optionLog.searchParams;
      const { data } = await getLogList({
        ...optSearch,
        subjectId: row.id,
      });
      console.log("查看日志的响应", data);
      const list = cloneDeep(data.data.records);
      optSearch.total = data.data.total;

      this.$refs.optionLog.show(list, row.id);

    },
    /** 日志分页 */
    async reloadOpt(id) {
      console.log("日志分页", id);
      const optSearch = this.$refs.optionLog.searchParams;
      const { data } = await getLogList({
        ...optSearch,
        subjectId: id,
      });
      console.log("查看日志的响应", data);
      const list = cloneDeep(data.data.records);
      this.$refs.optionLog.list = list;
      this.$refs.optionLog.searchParams.total = data.data.total;
    },
    // 添加内容标签
    insertCategory() {
      /** 取到输入框的数据 */
      let categoryInput = this.dialogForm.config.find(item => item.id === 51).value
      if (categoryInput) {
        /** 第一次不要加逗号 */
        if (this.dialogForm.category) {
          this.dialogForm.category += ','
        }
        this.dialogForm.category += categoryInput
      }
    },
    // 乐播媒资榜导入
    showImport() {
      this.$refs.importDialog.show()
    },
    // 获取关联应用
    getRelevanceApp() {
      getRelevanceApp().then((data) => {
        let res = data.data.data
        let arr = []
        res.forEach((item) => {
          arr.push({ name: item.name, id: item.id })
        })
        this.aplicationTypeList = arr
        this.thirdPartyAppList.value = arr.map(item => {
          return {
            label: item.name,
            value: item.id
          }
        })
      })
    },
    // 获取榜单列表
    getListContent(type) {
      if (type) {
        this.pagination.current = 1
      }
      let params = { ...this.searchForm }
      /** 根据当前tab增加分页参数 */
      // 类型（1：影视；2：比赛）
      if (this.tableTabs === 'live') {
        params.type = 2
      } else if (this.tableTabs === 'films') {
        params.type = 1
      } else if (this.tableTabs === 'lbMedia') {
        params.type = 3
      }
      if (Array.isArray(params.date) && params.date.length) {
        params.startTime = params.date[0]
        params.endTime = params.date[1]
      }
      delete params.date
      /** 处理直播时间 */
      if (Array.isArray(params.liveTime) && params.liveTime.length) {
        params.matchStartTime = params.liveTime[0]
        params.matchEndTime = params.liveTime[1]
      }
      delete params.liveTime
      params.current = this.pagination.current
      params.size = this.pagination.size
      getListContent(params).then((data) => {
        console.log(data);
        this.tableData = data.data.data.records
        this.pagination.current = data.data.data.current
        this.pagination.total = data.data.data.total
        this.pagination.size = data.data.data.size
      }).catch((err) => {
        console.log(err);
      })
    },
    // 列表按钮点击
    handleClick(row, type) {
      this.addTabs = this.tableTabs
      this.type = type
      if (type === 1) {
        this.addTabs === 'lbMedia' && (this.addTabs = 'live')
        // 新增
        this.visible = true
      } else if (type === 2) {
        // 编辑
        this.visible = true
        this.getEdit(row, 'edit')
      } else if (type === 3) {
        // 删除
        const param = {
          id: row.id
        }
        this.$confirm("此操作将永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          deleteListContent(param).then(() => {
            this.$message.success('删除成功')
            this.getListContent()
          }).catch(() => {
            this.$message.error('删除失败')
          })
        }).catch(() => { })
      } else if (type === 4) {
        this.type = 1
        // 复制
        this.visible = true
        this.getEdit(row, 'copy')
      }
    },
    //^ ^--------------上传相关-------------^ ^
    // 删除上传的图片
    handleRemoveImgs(file, fileList, item) {
      console.log(file, fileList);
      item.value = ''
      this[item.name] = []
    },
    // 上传的图片预览
    handlePictureCardPreview(file, item) {
      item.value = file.url;
      this.dialogVisible = true;
    },
    //上传图片
    handleChangeImgs(file, fileList, name) {
      const isPic = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.raw.type);
      const isLt2M = file.size / 1024 / 1024 < 2;
      // 指定jpg png格式
      if (!isPic || !isLt2M) {
        this.$message.error(!isPic ? '上传图片只能是 JPG/PNG 格式!' : '上传图片大小不能超过 2MB!');
        this[name] = []
        this.$forceUpdate()
        return
      }
      this[name] = [fileList[fileList.length - 1]]
      const formData = new FormData()
      formData.append('file', file.raw)
      putFile(formData).then((res) => {
        if (res.data.code === 200) {
          this.dialogForm.config.some((item) => {
            if (item.name === name) {
              item.value = res.data.data.link
              this.$refs[name][0].clearValidate();
              return true
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 返回图片
    uploadList(name) {
      return this[name] || []
    },
    //^ ^--------------新增/编辑相关-------------^ ^
    // 关闭新增/编辑弹窗
    onDialogClose() {
      this.visible = false
      this.loading = false
      this.resetData()
    },
    // 新增/修改保存
    handleEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loading = true
          let obj = {}
          obj.status = this.dialogForm.status
          obj.effectMode = this.dialogForm.effectMode
          obj.effectTime = this.dialogForm.effectTime
          obj.category = this.dialogForm.category
          /** 如果是失效 */
          if (obj.status === 0) {
            obj.effectMode = null
          }
          /** 如果指定有效时间 */
          if (obj.effectMode === 2) {
            obj.effectStartTime = obj.effectTime[0]
            obj.effectEndTime = obj.effectTime[1]
          } else {
            obj.effectStartTime = null
            obj.effectEndTime = null
          }
          delete obj.effectTime
          this.dialogForm.config.forEach((item) => {
            if (item.children) {
              item.children.forEach((subItem) => {
                obj[subItem.name] = subItem.value
              })
            } else {
              obj[item.name] = item.value
            }
          })
          // 校验宽度格式 (正整数) 范围是1-1000
          if (obj.imgWidth && !/^[1-9]|[1-9]\d{1,2}|1920$/.test(obj.imgWidth)) {
            this.$message.error('请输入1-1920的正整数图片宽度')
            this.loading = false
            return
          }
          /** 没有选择自定义输入图片宽度 */
          if (this.imgSelectWidth !== -1) {
            const picUrl = processImageUrl(obj.coverImg, this.imgSelectWidth)
            obj.coverImg = picUrl
          } else {
            /** 自定义输入图片宽度时 */
            if (!obj.imgWidth) {
              this.$message.error('请填写图片宽度')
              this.loading = false
              return
            }
            const picUrl = processImageUrl(obj.coverImg, obj.imgWidth)
            obj.coverImg = picUrl
          }
          delete obj.imgWidth
          obj.type = 1
          if (this.type === 2) {
            console.log('编辑', this.type);
            // 编辑传Id
            obj.id = this.editId
          }
          // 编辑
          updateListContent(obj).then(() => {
            this.getListContent()
            this.onDialogClose()
          }).catch((err) => {
            window.console.log(err);
            this.loading = false
          })
        }
        else {
          this.loading = false
          console.log("表单校验失败");
          return false;
        }
      })
    },
    // 处理编辑
    getEdit(row, type) {
      if (this.addTabs === 'films') {
        console.log('编辑', row);
        const params = {
          id: row.id
        }
        if (type === 'edit') {
          this.editId = row.id
        }

        // 获取榜单详情
        getListContentDetail(params).then((data) => {
          let res = data.data.data
          this.dialogForm.status = res.status
          this.dialogForm.effectMode = res.effectMode
          this.dialogForm.category = res.category
          /** 如果是指定时间生效 -> 组装指定时间 */
          if (res.effectMode && res.effectMode === 2) {
            this.dialogForm.effectTime = [res.effectStartTime, res.effectEndTime]
          }
          this.dialogForm.config.map((item) => {
            if (item.type === 'upload') {
              // 记录已上传的数据
              this[item.name] = res[item.name] ? [{ url: res[item.name] }] : []
            }
            if (item.children) {
              item.children.forEach(subItem => {
                subItem.value = res[subItem.name]
              });
            } else {
              item.value = res[item.name]
            }
          })
          console.log(this.dialogForm);
          const width = extractWidth(this.dialogForm.config[1].value)
          if (['300', '700'].includes(width)) {
            this.imgSelectWidth = width
          } else {
            /** 如果是旧的图片会找不到宽度 那么就默认选择300 */
            if (!width) {
              this.imgSelectWidth = '300'
            } else {
              this.imgSelectWidth = -1
              this.dialogForm.config[3].value = width
            }
          }
        }).catch(() => {
          this.$message.error('榜单查询失败')
        })
      } else if (this.addTabs === 'live') {
        this.getLiveEdit(row, type)
      } else if (this.addTabs === 'lbMedia') {
        this.getLbMediaEdit(row, type)
      }
    },
    /** 直播赛事的编辑回显处理 */
    getLiveEdit(row, type) {
      console.log("直播赛事的编辑回显处理", row);
      this.editId = row.id
      this.$nextTick(() => {
        const params = { ...row }
        if (type === 'copy') {
          delete params.id
        }
        this.$refs.liveForm.getForm(params)
      })
    },
    // 乐播媒资编辑回显
    getLbMediaEdit(row, type) {
      type === 'edit' && this.$nextTick(() => { this.$refs.lbMediaForm.getForm({ ...row }) })
    },
    // 重置数据
    resetData() {
      this.dialogForm.status = ''
      this.dialogForm.effectMode = ''
      this.dialogForm.effectTime = []
      this.dialogForm.category = ''
      this.dialogForm.config.map((item) => {
        if (item.children) {
          item.children.map((subItem) => {
            subItem.value = ''
          })
        } else {
          if (item.type === 'upload') {
            this[item.name] = []
          }
          item.value = ''
        }
      })
      this.imgSelectWidth = '300'
      this.editId = null
      this.$refs.liveForm.reset()
    },
    //^ ^--------------分页相关-------------^ ^
    /** 列表tab切换 */
    tableTabChange(tab) {
      console.log("列表tab切换", tab.name);
      this.addTabs = tab.name;
      this.getListContent()
    },
    // 改变页面数量
    handleSizeChange(val) {
      this.pagination.size = val
      this.getListContent()
    },
    // 当前页
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getListContent()
    },
    handleClickItem() {
      this.$nextTick(() => {
        let domImageMask = document.querySelector(".el-image-viewer__mask");  // 获取遮罩层dom
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      })
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 0 20px 30px 20px;
}

.listContentManage {
  .query-form-wrap {
    padding: 16px;
  }

  .block {
    text-align: right;
    margin: 16px 0;
  }
}

.el-input__inner {
  width: 300px !important;
}

.effectTime {
  .el-input__inner {
    width: 400px !important;
  }
}

.dialog-content-wrap {
  .children {
    display: flex;
    margin: 10px 0 20px -120px;

    .title {
      text-align: right;
      width: 150px;
      margin-right: 10px;
    }
  }
}

.btn {
  text-align: right;
}
</style>
